/**
 * SoundProperties.ts
 */
export class SoundProperties {
    constructor(name, component, channel, loop = false) {
        this.name = name;
        this.component = component;
        this.channel = channel;
        this.loop = loop;
    }
    equals(other) {
        return (this.name === other.name &&
            this.component === other.component &&
            this.channel === other.channel &&
            this.loop === other.loop);
    }
}
//# sourceMappingURL=SoundProperties.js.map